import React, { useContext, useMemo, useState } from 'react'
import { usePopper } from 'react-popper'
import { useSelector } from 'react-redux'

import { RootState } from 'typesafe-actions'

import { Avatar, H4 } from '@driftt/tide-core'

import Portal from 'components/Portal'
import { OrgUsersContext } from 'context/orgUsersContext'
import { getDisplayName, getUserDisplayRole } from 'utils/user'

import styles from './styles.module.css'

const UserSummaryTooltip: React.FC<{ userId: number; children?: React.ReactNode }> = ({
  userId,
  children
}) => {
  const [showTooltip, setShowTooltip] = useState<boolean>(false)
  const [referenceElement, setReferenceElement] = useState<HTMLElement | null>(null)
  const [popperElement, setPopperElement] = useState<HTMLElement | null>(null)

  const { styles: popperStyles, attributes: popperAttributes } = usePopper(
    referenceElement,
    popperElement,
    {
      placement: 'left',
      modifiers: [
        {
          name: 'offset',
          options: {
            offset: [0, 12]
          }
        }
      ]
    }
  )

  const orgUsersById = useContext(OrgUsersContext)
  const currentOrg = useSelector<RootState, any>(state => state.org)
  const mentionedUser = useMemo(() => orgUsersById[userId], [orgUsersById, userId])
  const displayRole = getUserDisplayRole(mentionedUser)

  return (
    <>
      <span
        ref={setReferenceElement}
        onMouseEnter={() => setShowTooltip(true)}
        onMouseLeave={() => setShowTooltip(false)}>
        {children}
      </span>
      {mentionedUser && showTooltip && (
        <Portal>
          <div
            className={styles.userSummaryContainer}
            ref={setPopperElement}
            style={popperStyles.popper}
            {...popperAttributes.popper}>
            <div className={styles.userSummaryAvatar}>
              <Avatar user={mentionedUser} />
            </div>
            <div>
              <H4>{getDisplayName(mentionedUser)}</H4>
              {displayRole ? `${displayRole} at ${currentOrg.name}` : currentOrg.name}
            </div>
          </div>
        </Portal>
      )}
    </>
  )
}

export default UserSummaryTooltip
